// Funções de formatação
export const formatCurrency = (value) => {
  if (!value && value !== 0) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

export const formatDateBR = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('pt-BR');
};

// Função para formatar CNPJ
export const formatCNPJ = (cnpj) => {
  if (!cnpj) return '';
  
  // Remove todos os caracteres não numéricos
  const cleanCNPJ = cnpj.replace(/\D/g, '');
  
  // Garante que tem 14 dígitos preenchendo com zeros à esquerda
  const paddedCNPJ = cleanCNPJ.padStart(14, '0');
  
  // Aplica a máscara XX.XXX.XXX/XXXX-XX
  return paddedCNPJ.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    '$1.$2.$3/$4-$5'
  );
};
